<template>
  <div class="wrapper-profile-customer">

    <div class="test-data history-profile">
      <h2 style="font-size:18px; margin-bottom:20px;">STAFF DETAILS</h2>
      <div  class="fl" style="padding-right:20px">
        <td><img :src=staff.avatar alt="avatar" width="84" /></td>
      </div>
      <div class="fl" style="width:28%;">
        <div><span class="fwb">Name:</span>&nbsp;<span>{{staff.name}}</span></div>
        <div><span class="fwb">Email:</span>&nbsp;<span>{{staff.email}}</span></div>
      </div>
    </div>

    <hr class="clear" />

    <div id="registered-customer" class="test-data history-profile">
      <br />
      <div style="float:right">
        <date-range-picker
                style="position: relative;top: 17px;right: 8px"
                v-model="range"
                display-format="DD-MM-YYYY"
                no-title
                :input-props="{ solo: false, 'prepend-inner-icon': 'date_range', style: { width: '260px' }}"
                :menu-props="{ offsetY: true, closeOnContentClick: false }"
                :presets="dateRangePresets"
                v-on:menu-closed="getDataFromApi"
        ></date-range-picker>
      </div>
      <div style="float:left">
        <h2 style="font-size:18px; margin-bottom:20px;">Registered Customers</h2>
        <table>
          <thead>
            <tr>
              <th>Customer</th>
              <th>First Sale</th>
              <th>Second Sale</th>
              <th>Total Sales</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in registered" :key="index">
              <td>{{ item.customer_name }}</td>
              <td>{{ item.first_sale }}</td>
              <td>{{ item.second_sale }}</td>
              <td>{{ item.total_sales }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="float:left; margin-left:10%">
        <h2 style="font-size:18px; margin-bottom:20px;">Direct From Employee</h2>
        <table>
          <thead>
          <tr>
            <th>Customer</th>
            <th>Earned</th>
            <th>Redeemed</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in direct" :key="index">
            <td valign="top">{{ item.name }}</td>
            <td valign="top">
              <table style="margin-top:0">
                <thead>
                <tr>
                  <th>Points</th>
                  <th>Revenue</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in item.earned" :key="index">
                  <td>{{ item.points }}</td>
                  <td>{{ item.revenue }}</td>
                </tr>
                </tbody>
              </table>
            </td>
            <td valign="top">
              <table style="margin-top:0">
                <thead>
                <tr>
                  <th>Points</th>
                  <th>Revenue</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in item.redeem" :key="index">
                  <td>{{ item.points }}</td>
                  <td>{{ item.revenue }}</td>
                </tr>
                </tbody>
              </table>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <br />
    </div>


    <hr class="clear" />

    <div class="test-data history-profile">
      <h2 style="font-size:18px; padding-top: 20px">CUSTOMER HISTORY</h2>
      <table>
        <thead>
        <tr>
          <th>Time & Date</th>
          <th>Location</th>
          <th>Customer</th>
          <th>Description</th>
          <th>Transaction</th>
          <th>Receipt Ref</th>
          <th>Cancellation</th>
          <th>Points</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in history" :key="index">
          <td>{{item.created_at}}</td>
          <td>{{ item.location && item.location.google_links ? item.location.google_links : item.location }}</td>
          <td>{{item.customer ? item.customer : '' }}</td>
          <td>{{ item.event && item.event.name ? item.event.name : item.event }}</td>
          <td>{{item.shopping_value}}</td>
          <td>{{item.transaction_number}}</td>
          <td>{{item.reason_deleted}}</td>
          <td>{{item.points}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        range: {},
        dateRangePresets: [
          {
            label: 'Today',
            range: [
              moment().format('YYYY-MM-DD'),
              moment().format('YYYY-MM-DD')
            ]
          },
          {
            label: 'Yesterday',
            range: [
              moment().add(-1, 'days').format('YYYY-MM-DD'),
              moment().add(-1, 'days').format('YYYY-MM-DD')
            ]
          },
          {
            label: 'Last 7 Days',
            range: [
              moment().add(-7, 'days').format('YYYY-MM-DD'),
              moment().add(-1, 'days').format('YYYY-MM-DD')
            ]
          },
          {
            label: 'Last 30 Days',
            range: [
              moment().add(-30, 'days').format('YYYY-MM-DD'),
              moment().add(-1, 'days').format('YYYY-MM-DD')
            ]
          },
          {
            label: 'Last 90 Days',
            range: [
              moment().add(-90, 'days').format('YYYY-MM-DD'),
              moment().add(-1, 'days').format('YYYY-MM-DD')
            ]
          }
        ],
        model: 'App\\Staff',
        staff: [],
        city: '',
        country: '',
        history: [],
        registered: [],
        direct: [],
        dataListEvents: null,
        dataForm: false,
        currentItem: false,
        settings : {
          dialog_width: false
        },
        uuid: false,
        today: new Date(),
        actionPoint: null
      }
    },
    mounted() {
      this.uuid = this.$route.params.uuid;
      this.getDataFromApi().then(data => {
        console.log('job done')
      });

    },
    watch: {
      dataListEvents () {
        if (this.dataListEvents.reload) {
          console.log('comes here reload');
          this.reloadData()
        }
      }
    },
    methods: {
      getDataFromApi() {
        this.loading = true
        return new Promise((resolve, reject) => {
          let that = this;
          axios.post('/app/staff', {
            uuid: this.uuid,
            start: this.range.start || null,
            end: this.range.end || null
          }).then(res => {
            if (res.status === 200) {
              this.staff = res.data.staff;
              this.history = res.data.history;
              this.registered = res.data.registered;
              this.direct = res.data.direct;
            }
          }).catch(err => console.log(err.response.data)).finally(() => that.loading = false);
        })
      },
      deleteRecords () {
        this.$root.$confirm(this.$t('delete'), this.$t('confirm_delete'))
                .then((confirm) => {
                  if (confirm) {
                    this.loading = true
                    let that = this
                  }
                })
      },
      reloadData () {
        this.watchPagination = false
        this.loading = true
        this.getDataFromApi()
                .then(data => {
                  this.rows = data.items
                  this.watchPagination = true
                })
      }
    }
  }
</script>